












	import Vue from 'vue';
    import TerminOverviewComp from "../../components/raid/TerminOverviewComp.vue";

    export default Vue.extend({
        name: "TerminePage",
        components: {TerminOverviewComp},
        computed: {
            showNeuerTermin: function(): boolean {
                return this.$vStore.getters.raidRole > 0;
            }
        }
    })
